import { CrudSort } from '@refinedev/core';

export const dealFilterDesc: CrudSort = {
  field: 'deal_id',
  order: 'desc',
};
